import styled from 'styled-components';
import { Table as AntdTable } from 'antd';

const { Column, Summary } = AntdTable;

export const Table = styled(AntdTable)`
  width: 100%;
  overflow-x: auto;   
  .ant-table th,
  .ant-table td {
    min-width: 150px;
    white-space: nowrap;
    
  }
`;

export const TableSum = styled(Summary)``;

export const TableSumCell = styled(Summary.Cell)`
  & .ant-table-summary > tr > th, .ant-table-summary > tr > td {
    background-color: #f2f9ff;
    color: red;
  }

`;

export const TableColumn = styled(Column)``;
